import React from "react";
import { MediaBaseUrl, SW_LOGO } from "../../actions/api";
import { Link } from "react-router-dom";

const randomIntFromInterval = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
}
const date = new Date();
export function LoginLayout(props) {
    const { children } = props;

    var active1 = '';
    var active2 = '';
    var active3 = '';
    var active4 = '';
    var randomSlide =  randomIntFromInterval(1, window.location.pathname.includes("display") ? 4 : 3);
    var active = ""

    switch (randomSlide) {
        case 1:
            active1 = 'active';
            break;
        case 2:
            active2 = 'active';
            break;
        case 3:
            active3 = 'active';
            break;
        case 4:
            active4 = 'active';
            break;
        default:
            active = '';
    }

    return <>
        <div className="login-container">
            <div className="custom-row row">
                <div className="custom-col-8 col-sm-8 form_screen">
                    <div className="form_sec">
                        <div className="logoLogin">
                            <a href={`https://socialwalls.com`} style={{ cursor: 'pointer' }}> <img src={SW_LOGO} width="180" alt="Taggbox" /> </a>

                        </div>
                        <div className="form_wrap">
                            <div className="form_content_wrap"> {children} </div>
                        </div>
                    </div>
                    <div className="login-footer">
                        <div className="row text-center">
                            <div className="col-xs-12">
                                <div className="login-copyright">
                                    {!window.location.pathname.includes("mfa_auth") ? <> <div className="terms-condition-link"> <p>By Clicking on Login/Signup you are agree to our <a href="https://socialwalls.com/terms-of-service/" target="_blank">Terms and Conditions</a> and <a href="https://socialwalls.com/privacy-policy/" target="_blank">Privacy Policy</a></p> </div>
                                    <p>Copyright @ {date.getFullYear()} </p>
                                    </>:
                                    <p className="m-0 text-underline"><Link to={`/accounts/login`} className="btnSignUp text-dark fw-bold text-decoration-underline">Sign in to another account</Link></p>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="custom-col-4 col-sm-4 form_side_content">
                    <div className="form_content">
                        <div className="form_cont_in">
                            <div className="g2_badge">
                                <img className="img-responsive" src={`${MediaBaseUrl}form-icons/g2-badge.svg?var=18`} alt="High Performer" />
                            </div>
                            <div className="testimonials">
                                <h3 style={{ color: '#fff' }}> Why do people like Social Walls? </h3>

                                <div className="form_cont_slides">
                                    <div id="carousel" className="carousel slide">
                                        <div className="carousel-inner">
                                        <>
                                            {active1 && active1.length > 0 ? <div className={`item ${active1}`}>
                                                <ul className="star-rating">
                                                {[...Array(5)].map((item,index)=><li key={index}><i className="fa fa-star" style={{ color: '#ffd501' }}></i></li>)}
                                                </ul>
                                                <p>{`Social Walls provided plenty of value for the social events of real estate with its easiness of setting up and its reliability - and moderation capabilities for our Posts.`}</p>
                                            </div> : null}
                                            {active2 && active2.length > 0 ? <div className={`item ${active2}`}>
                                                <ul className="star-rating">
                                                 {[...Array(5)].map((item,index)=><li key={index}><i className="fa fa-star" style={{ color: '#ffd501' }}></i></li>)}
                                                </ul>
                                                <p>{`Social Walls is an exceptional product revolutionizing how we engage with our audience. It effortlessly aggregates and displays user-generated content, creating a captivating and interactive experience.`}</p>
                                            </div> : null}
                                            {active3 && active3.length > 0 ? <div className={`item ${active3}`}>
                                                <ul className="star-rating">
                                                {[...Array(5)].map((item,index)=><li key={index}><i className="fa fa-star" style={{ color: '#ffd501' }}></i></li>)}
                                                </ul>
                                                <p>{`Social Walls is a game-changer. It enhanced our internal event and unleashed the potential for employee participation. Thanks to Social Walls, we've seen a significant boost in employee advocacy with the SnapUp.`}</p>
                                            </div> : null}
                                            
                                            {window.location.href.includes("display") ? active4 && active4.length > 0 ? <div className={`item ${active4}`}>
                                                <ul className="star-rating">
                                                {[...Array(5)].map((item,index)=><li key={index}><i className="fa fa-star" style={{ color: '#ffd501' }}></i></li>)}
                                                </ul>
                                                <p>We curate and display engaging UGC to captivate our audience. With social wall, we have boosted brand visibility, fostered authentic interactions, and created a vibrant community around our brand.</p>
                                            </div> : null : null}
                                            
                                            {window.location.href.includes("display") ? <ol className="carousel-indicators">
                                                <li data-target="#carousel" data-slide-to="0" className={`${active1}`}>
                                                    <div className="client_img" style={{ backgroundImage: `url(${MediaBaseUrl}form-icons/melanie-m..jpeg)` }}></div>
                                                    <div className="o_event">
                                                        <strong>Melanie M.</strong>
                                                        <p><span></span>Industry Relations Special Projects Manager</p>
                                                    </div>
                                                </li>
                                                <li data-target="#carousel" data-slide-to="1" className={`${active2}`}>
                                                    <div className="client_img" style={{ backgroundImage: `url(${MediaBaseUrl}form-icons/john-parker.jpg)` }}></div>
                                                    <div className="o_event">
                                                        <strong>John Parker</strong>
                                                        <p><span></span>Event Manager</p>
                                                    </div>
                                                </li>
                                                <li data-target="#carousel" data-slide-to="2" className={`${active3}`}>
                                                    <div className="client_img" style={{ backgroundImage: `url(${MediaBaseUrl}form-icons/christine-reale.jpg)` }}></div>
                                                    <div className="o_event">
                                                        <strong>Christine Reale</strong>
                                                        <p><span></span>Resource Professional</p>
                                                    </div>
                                                </li>
                                                <li data-target="#carousel" data-slide-to="3" className={`${active4}`}>
                                                    <div className="client_img" style={{ backgroundImage: `url(${MediaBaseUrl}form-icons/jennifer_hardee.jpg)` }}></div>
                                                    <div className="o_event">
                                                        <strong>Jennifer Hardee</strong>
                                                        <p><span></span>Sr. Marketing Manager</p>
                                                    </div>
                                                </li>
                                            </ol>:<ol className="carousel-indicators">
                                            <li data-target="#carousel" data-slide-to="0" className={`${active1}`}>
                                                <div className="client_img" style={{ backgroundImage: `url(${MediaBaseUrl}form-icons/chris-luck.jpg)` }}></div>
                                                <div className="o_event">
                                                    <strong>Chris Luck</strong>
                                                    <p><span></span>Managing Editor</p>
                                                </div>
                                            </li>
                                            <li data-target="#carousel" data-slide-to="1" className={`${active2}`}>
                                                <div className="client_img" style={{ backgroundImage: `url(${MediaBaseUrl}form-icons/mike-kernis.jpg)` }}></div>
                                                <div className="o_event">
                                                    <strong>Mike Kernis</strong>
                                                    <p><span></span>Marketing Manager</p>
                                                </div>
                                            </li>
                                            <li data-target="#carousel" data-slide-to="2" className={`${active3}`}>
                                                <div className="client_img" style={{ backgroundImage: `url(${MediaBaseUrl}form-icons/katelin-holloway.jpg)` }}></div>
                                                <div className="o_event">
                                                    <strong>Katelin Holloway</strong>
                                                    <p><span></span>Social Media Coordinator</p>
                                                </div>
                                            </li>
                                        </ol>}
                                        </>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="trusted_by">
                                <h4 style={{ color: '#fff' }}>Trusted by these companies</h4>
                                <ul className="clients_logo">
                                    <li><img className="img-responsive" src={`${MediaBaseUrl}form-icons/audi.svg`} /></li>
                                    <li><img className="img-responsive" src={`${MediaBaseUrl}form-icons/yale.svg`} /></li>
                                    <li><img className="img-responsive" src={`${MediaBaseUrl}form-icons/ikea.svg`} /></li>
                                    <li><img className="img-responsive" src={`${MediaBaseUrl}form-icons/paypal.svg`} /></li>
                                    <li><img className="img-responsive" src={`${MediaBaseUrl}form-icons/loreal.svg`} /></li>
                                </ul>
                                <h5>+10,000 more</h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}
